import { useRef, useImperativeHandle, forwardRef, memo } from 'react'
import { EditorWorkspace, EditorWorkspaceRef } from './EditorWorkspace'

export interface EditorContainerRef {
  getPreviewElement: () => HTMLDivElement | null
}

/**
 * 编辑器容器组件
 * 包含编辑器工作区
 */
const EditorContainerInner = forwardRef<EditorContainerRef>((_props, ref) => {
  const workspaceRef = useRef<EditorWorkspaceRef>(null)

  useImperativeHandle(ref, () => ({
    getPreviewElement: () => workspaceRef.current?.getPreviewElement() || null
  }))

  return (
    <div className="h-full">
      <EditorWorkspace ref={workspaceRef} />
    </div>
  )
})

EditorContainerInner.displayName = 'EditorContainerInner'

export const EditorContainer = memo(EditorContainerInner)
EditorContainer.displayName = 'EditorContainer'